export default __webpack_public_path__ + "static/media/blip-friendly.f17c8a5b.svg";